import { format } from "date-fns";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaChevronRight } from "react-icons/fa";

import { useGetMyAccounts } from "@/api/queries";
import { useUIStateStore } from "@/store/uiStateStore";

import useGetColours from "../helpers/getColours";
import ChangeAccountModal from "./ChangeAccountModal";
import ChooseAccountModal from "./ChooseAccountModal";
import LoadingSmall from "./LoadingSmall";
import RebrandButtonLink from "./RebrandButtonLink";
import Table from "./Table";

function ExpandCell() {
  return <div className="float-right"><FaChevronRight /></div>;
}

function TopGigs({ data, isLoading, isError }) {
  const isTunecore = useUIStateStore(state => state.isTunecore);
  const { t } = useTranslation("dashboard");
  const myAccounts = useGetMyAccounts();
  const { highlightColour } = useGetColours();
  const [switchModal, setSwitchModal] = useState(null);
  const [accountChoiceModal, setAccountChoiceModal] = useState(false);

  const columns = React.useMemo(
    () => [
      {
        Header: t("dashboard:ra-column-venue", "Venue Name"),
        accessor: "venueName",
        width: "33%",
        id: "colTopGigsVenue",
      },
      {
        Header: t("dashboard:ra-column-date", "Date"),
        accessor: "created",
        width: "33%",
        id: "colTopGigsDate",
        Cell: ({ row }) => (
          ((row?.values?.colTopGigsDate && row?.values?.colTopGigsDate !== "0000-00-00") ? format(Date.parse(row.values.colTopGigsDate), "yyyy-MM-dd") : null)
        ),
      },
      {
        Header: t("dashboard:ra-column-performer", "Performer"),
        accessor: "performer",
        width: "30%",
        id: "colTopGigsPerformer",
      },
      {
        Header: "",
        accessor: "expander",
        width: "5%",
        Cell: ExpandCell,
      },
    ],
    [t],
  );

  const onRowClick = (row) => {
    const song = row.original;
    // switch account, and go to gigs
    setSwitchModal({
      artistaccountcode: song.artistaccountcode,
      cataloguecode: song.catalogueCode,
      name: song.accountname,
    });
  };

  return (
    <>
      {!!switchModal
        && <ChangeAccountModal accounts={myAccounts?.data?.artistaccounts} to="/gigs" setSwitchModal={setSwitchModal} account={switchModal} />}
      {!!accountChoiceModal
        && (
          <ChooseAccountModal
            open={accountChoiceModal}
            title={t("dashboard:choose-account-gigs-modal-header", "Choose Account")}
            to="/gigs/claim"
            setAccountChoiceModal={setAccountChoiceModal}
            accounts={myAccounts?.data?.artistaccounts}
            nonAdminTo="/gigs/"
          />
        )}
      <div className={`${isTunecore ? "bg-layer-inverse text-white" : "bg-white text-black"} w-full lg:w-1/2 p-8 rounded-lg`}>
        <div className="flex flex-row items-center justify-between mb-5">
          <h2 className="text-xl font-medium">{t("dashboard:recently-added-gigs-header", "Recently Added Gigs")}</h2>
          <RebrandButtonLink
            plusIcon
            id="btnTopGigAddGig"
            onClick={() => { setAccountChoiceModal(true); }}
          >
            {t("dashboard:add-new-gig-link", "Add new gig")}
          </RebrandButtonLink>
        </div>
        {isLoading
          && <LoadingSmall />}
        {!isLoading && !isError && data
          && (
            <div>
              <Table
                area="TopGigs"
                data={data}
                columns={columns}
                min={5}
                highlightColour={highlightColour}
                revealComponent={null}
                onRowClick={onRowClick}
                searchSuffix={t("common:gigs", "Gigs")}
                disableSearch
                bgClass={`${isTunecore ? "bg-layer-inverse" : "bg-white"} rounded-lg p-0`}
                sortBy={{
                  id: "verifieddate",
                  desc: true,
                }}
              />
            </div>
          )}
        {isError
          && (
            <div>
              <p>{t("dashboard:recent-gigs-error", "Error with recent gigs")}</p>
            </div>
          )}
      </div>
    </>
  );
}

export default TopGigs;
